import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

const FlashSuccess: React.FC<Props> = ({ children }) => (
  <div
    className="mb-[30px] flex flex-col mt-2.5 text-lg font-medium leading-5"
    data-test-flash-message="success"
  >
    <div
      className={clsx(
        'py-3 px-6 rounded bg-[#DAE4EF] text-[#000000b3] mx-auto max-w-[600px]',
        'self-center text-center whitespace-pre-line border-[3px] border-solid',
        'border-[#1A8927] bg-[#CCEFD0]',
      )}
    >
      {children}
    </div>
  </div>
);

export default observer(FlashSuccess);
